// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';
/**
 * 基础菜单
 */
// 商品管理
import Goods from '@/views/goods/Goods';
// 机器信息管理
import Machine from '@/views/machine/Machine';
// 货道信息管理
import MachineAisle from '@/views/machine/MachineAisle';
/**
 * 订单管理
 */
// 交易订单
import Order from '@/views/pay/Order';
/**
 * 系统管理
 */
// 用户管理
import user from '@/views/system/user';
// 菜单管理
import Module from '@/views/system/Module';
// 角色管理
import Role from '@/views/system/Role';
// 公司管理
import Dept from '@/views/system/Dept';
// 系统环境变量
import Variable from '@/views/system/Variable';
// 权限管理
import Permission from '@/views/system/Permission';
// 代理管理
import agent from '@/views/system/agent';
/**
 * 支付管理
 */
// 支付配置信息
import MachineConfig from '@/views/machine/MachineConfig';
// 支付配置
import Config from '@/views/pay/Config';
/**
 * 数据监控
 */
// 监控查询
import druidLogin from '@/views/druid/login';

// 图表界面
import statistics from '@/views/charts/statistics';

/**
 * 景点
 */
import camplist from '@/views/camp/camps';
import camplist2 from '@/views/camp/camps2';
import camplist3 from '@/views/camp/camps3';
import camplist4 from '@/views/camp/camps4';
import camplist5 from '@/views/camp/camps5';
import camplist6 from '@/views/camp/camps6';
import camplist7 from '@/views/camp/camps7';
import camplist8 from '@/views/camp/camps8';
import camplist9 from '@/views/camp/camps9';
import camplist10 from '@/views/camp/camps10';
import camplist11 from '@/views/camp/camps11';
import camplist12 from '@/views/camp/camps12';
import camplist13 from '@/views/camp/camps13';
import camplist14 from '@/views/camp/camps14';
import camplist15 from '@/views/camp/camps15';
import camplist16 from '@/views/camp/camps16';
import camplist17 from '@/views/camp/camps17';
import campinfo from '@/views/camp/info';
import camptype from '@/views/camp/type';
import lineList from '@/views/lines/lines';
import maps from '@/views/maps/maps';
import maps2 from '@/views/maps/maps2';
import scDetailslist from '@/views/scDetails/scDetails';

// 启用路由
Vue.use(Router);

// 导出路由
export default new Router({
    routes: [{
        path: '/',
        name: '',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/login',
        name: '登录',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/index',
        name: '首页',
        component: index,
        iconCls: 'el-icon-tickets',
        children: [{
            path: '/goods/Goods',
            name: '商品管理',
            component: Goods,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/machine/Machine',
            name: '机器信息管理',
            component: Machine,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/machine/MachineAisle',
            name: '货道信息管理',
            component: MachineAisle,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/pay/Order',
            name: '交易订单',
            component: Order,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/user',
            name: '用户管理',
            component: user,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/agent',
            name: '代理管理',
            component: agent,
            meta: {
                requireAuth: true
            }
        }, {
            // 代理名下用户子列表（动态菜单进入，带 agentId/name 查询参数）
            path: '/system/AgentUser',
            name: '代理用户',
            component: Role,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Module',
            name: '菜单管理',
            component: Module,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Role',
            name: '角色管理',
            component: Role,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Pa',
            name: '公司管理',
            component: Dept,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Variable',
            name: '系统环境变量',
            component: Variable,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Permission',
            name: '权限管理',
            component: Permission,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/machine/MachineConfig',
            name: '支付配置信息',
            component: MachineConfig,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/pay/Config',
            name: '支付配置',
            component: Config,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/druid/login',
            name: '监控查询',
            component: druidLogin,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/charts/statistics',
            name: '数据可视化',
            component: statistics,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/camp/camplist',
            name: '打卡景点列表',
            component: camplist,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/camp/camplist2',
            name: '打卡景点列表',
            component: camplist2,
            meta: {
                requireAuth: true
            }
        }
            ,
        {
            path: '/camp/camplist3',
            name: '打卡景点列表',
            component: camplist3,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/camp/camplist4',
            name: '打卡景点列表',
            component: camplist4,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/camp/camplist5',
            name: '打卡景点列表',
            component: camplist5,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/camp/camplist6',
            name: '打卡景点列表',
            component: camplist6,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/camp/camplist7',
            name: '打卡景点列表',
            component: camplist7,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/camp/camplist8',
            name: '打卡景点列表',
            component: camplist8,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/camp/camplist9',
            name: '打卡景点列表',
            component: camplist9,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/camp/camplist10',
            name: '打卡景点列表',
            component: camplist10,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/camp/camplist11',
            name: '打卡景点列表',
            component: camplist11,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/camp/camplist12',
            name: '打卡景点列表',
            component: camplist12,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/camp/camplist13',
            name: '打卡景点列表',
            component: camplist13,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/camp/camplist14',
            name: '打卡景点列表',
            component: camplist14,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/camp/camplist15',
            name: '打卡景点列表',
            component: camplist15,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/camp/camplist16',
            name: '打卡景点列表',
            component: camplist16,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/camp/camplist17',
            name: '替换列表',
            component: camplist17,
            meta: {
                requireAuth: true
            }
        },
         {
            path: '/lines/lines',
            name: '游览路线',
            component: lineList,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/scDetails/scDetailslist',
            name: '景点详情',
            component: scDetailslist,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/camp/camptype',
            name: '景点分类',
            component: camptype,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/camp/campinfo',
            name: '攻略求助',
            component: campinfo,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/maps/maps',
            name: '页面管理',
            component: maps,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/maps/maps2',
            name: '页面管理',
            component: maps2,
            meta: {
                requireAuth: true
            }
        },]
    }]
})



// WEBPACK FOOTER //
// ./src/router/index.js